// extracted by mini-css-extract-plugin
module.exports = {"brow":"Brow-styles-module--brow--1LjAU","nobg":"Brow-styles-module--nobg--zjdGc"};